<template>
    <pendo-modal
        :cancel-button-config="{ disabled: marketoLoading }"
        :confirm-button-config="{ disabled: marketoLoading || !marketoForm, label: 'Let\'s talk' }"
        :show-close="false"
        :visible="visible"
        height="auto"
        title="Ready to unlock more from Pendo?"
        width="480px"
        @cancel="dismiss"
        @close="dismiss"
        @confirm="sendMarketoForm">
        <template #body>
            <div
                v-if="!marketoForm || marketoLoading"
                class="contact-sales--loading">
                <pendo-loading-indicator size="large" />
            </div>
            <div
                v-show="marketoForm && !marketoLoading"
                class="contact-sales--form-wrapper">
                <p class="contact-sales--form-preamble">
                    It looks like you’re ready to get even more from your Pendo account. Let’s discuss how we can help.
                </p>
                <form id="mktoForm_2570" />
                <form class="contact-sales--form">
                    <pendo-input
                        v-for="field in formFields"
                        :key="field.key"
                        v-model="field.value"
                        :invalid="field.invalid"
                        :labels="{
                            top: field.label,
                            bottom: field.invalid ? (field.value ? field.validation : 'Required') : '',
                        }"
                        :placeholder="field.placeholder"
                        :type="field.type"
                        class="contact-sales--form-field"
                        sanitize
                        @blur="
                            () => {
                                field.value = field.value.trim();
                            }
                        "
                        @input="updateMarketoValue(field)" />
                </form>
            </div>
        </template>
    </pendo-modal>
</template>

<script>
// disabled because props are used in marketo mixin
/* eslint internal-rules/no-unused-properties: 0 */
import { mapGetters } from 'vuex';
import { EventBus } from '@utils/event-bus.js';
import { PendoModal, PendoLoadingIndicator, PendoInput } from '@pendo/components-vue3';
import MarketoFormMixin from '../mixins/marketo-form.mixin.js';
import { STARTER_2024_PACKAGE } from '../free.constants.js';

export function openContactSalesForm (source) {
    EventBus.$emit('openContactSalesForm', source);
}

export default {
    name: 'ContactSalesForm',
    components: {
        PendoModal,
        PendoLoadingIndicator,
        PendoInput,
    },
    mixins: [MarketoFormMixin],
    data () {
        return {
            visible: false,
            marketoScript: null,
            marketoForm: null,
            formFields: [],
            submissionTried: false,
            marketoLoading: false,
            source: null,
            formId: 2570,
            requiredFieldNames: [],
        };
    },
    computed: {
        ...mapGetters({
            isPendoFree: 'subscription/isPendoFree',
            isInTrial: 'subscription/isInTrial',
            purchasableSelfServicePlan: 'subscription/purchasableSelfServicePlan',
            isStarter2024Package: 'subscription/isStarter2024Package',
        }),
    },
    created () {
        EventBus.$on('openContactSalesForm', this.handleClick);
    },
    beforeUnmount () {
        EventBus.$off('openContactSalesForm', this.handleClick);
    },
    methods: {
        handleClick (source) {
            if (!(this.purchasableSelfServicePlan === STARTER_2024_PACKAGE.planId || this.isStarter2024Package)) {
                let url = '';

                if (source === 'data-sync') {
                    url = 'https://www.pendo.io/?q_showExperience=experience-1733339901350';
                } else if (this.isPendoFree || this.isInTrial) {
                    url = 'https://www.pendo.io/?q_showExperience=experience-1733839747724';
                } else {
                    url = 'https://www.pendo.io/?q_showExperience=experience-1733839126846';
                }

                window.open(url, '_blank');

                return;
            }
            this.showModal();
        },
        showModal () {
            this.visible = true;
            if (this.marketoScript === null) {
                this.initMarketoScript(this);
            }
        },
        dismiss () {
            this.visible = false;
            if (this.marketoForm) {
                this.clearForm();
            }
        },
        async sendMarketoForm () {
            this.marketoLoading = true;
            const marketoPromise = this.submitFormToMarketo();
            try {
                if (marketoPromise) {
                    await marketoPromise;
                }
                this.clearForm();
                this.visible = false;
                this.marketoLoading = false;
                this.openConfirmationGuide('[do not delete] Contact Sales Form Sent');
            } catch {
                window.pendo.track('contact-sales-marketo-failed');
                this.marketoLoading = false;
            }
        },
    },
};
</script>

<style lang="less" scoped>
.contact-sales {
    &--modal-body {
        display: block;
        height: auto;
        width: 100%;
    }

    &--form-wrapper {
        display: flex;
        width: 100%;
        flex-direction: column;
        justify-content: center;

        .contact-sales--form-preamble {
            padding: 0;
        }

        #mktoForm_2570 {
            display: none;
        }

        .contact-sales--form {
            display: flex;
            width: 100%;
            flex-direction: column;
            justify-content: center;

            &-field {
                margin: 8px 0;
            }
        }
    }

    &--loading {
        display: flex;
        height: 100%;
        width: 100%;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
}
</style>
